import * as React from "react";
import { PropertyPillFilters as SharedUiWrappedPropertyPillFilters } from "@shared-ui/lodging-property-pill-filters";
import { ComponentProps } from "typings/flexFramework/FlexComponent";
import { PropertyBexApiWrapper } from "components/shared/BexApiWrapper/PropertyBexApiWrapper";
import { UitkSpacing } from "uitk-react-spacing";

const WrappedPropertyPillFilters = PropertyBexApiWrapper(SharedUiWrappedPropertyPillFilters);

export const PropertyPillFilters: React.FC<ComponentProps> = ({ context }) => (
  <UitkSpacing margin={{ block: "three" }}>
    <div>
      <WrappedPropertyPillFilters context={context} />
    </div>
  </UitkSpacing>
);

export default PropertyPillFilters;
